import React, { useLayoutEffect } from 'react';
import Banners from './Banners';
import ChargingSolutions from './ChargingSolutions/ChargingSolutions';
import EVValueSection from './EVValueSection';
import FourSteps from './FourSteps';
import MobileCarousel from '../MobileApp/05_screen_carousel'
import AcChargers from './02_ac_chargers_title';
import EVPromoSection from './EVPromoSection/EVPromoSection';
import banner from '../../Assets/resource/banner.png'
import FAQ from './Faq';
import StepsSection from '../../Molecules/StepsSection/StepsSection';
import ContactForms from '../Controllers/ContactForms';

function HomeCharger() {
    useLayoutEffect(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }, []);
  return (
    <>
        <Banners />
        <EVValueSection />
        <ChargingSolutions />
        <FourSteps />
        <div className='containers-min mx-auto'>
          <img src={banner} alt="img" />
        </div>
        <EVPromoSection />
        <AcChargers />
        <MobileCarousel />
        <StepsSection />
        <FAQ />
        <ContactForms className="true"/> 
    </>
  )
}

export default HomeCharger